import React from "react";
import { RibbonWrapper } from "@qgiv/core-donor";
import ConnectedMatchingCampaignsContent from "./ConnectedMatchingCampaignsContent";
import MatchingCampaignsCountdown from "./MatchingCampaignsCountdown";

/**
 * @param {object} props
 * @param {string} props.endDate
 * @param {object} props.matchingCampaignsContentProps
 * @param {object} props.ribbonWrapperProps
 * @param {boolean} props.shouldDisplayCountdown
 * @returns {React.ReactElement}
 */
const MatchingCampaignsCallout = ({
    endDate,
    matchingCampaignsContentProps,
    ribbonWrapperProps,
    shouldDisplayCountdown = false,
}) => (
    <div className="qg-vendor-matching-campaign-callout -callout ribbon-wrapper-container">
        {shouldDisplayCountdown && (
            <RibbonWrapper {...ribbonWrapperProps}>
                <MatchingCampaignsCountdown endDate={endDate} />
            </RibbonWrapper>
        )}
        <div className="qg-vendor-matching-campaign-content">
            <ConnectedMatchingCampaignsContent
                {...matchingCampaignsContentProps}
            />
        </div>
    </div>
);

export default MatchingCampaignsCallout;
